import { render, staticRenderFns } from "./scoreDialog.vue?vue&type=template&id=2c5a7e5e&scoped=true&"
import script from "./scoreDialog.vue?vue&type=script&lang=js&"
export * from "./scoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./scoreDialog.vue?vue&type=style&index=0&id=2c5a7e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a7e5e",
  null
  
)

export default component.exports